/**
 * Reusable stateless form component for Sentiment Question
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import form components
import { NumberInput, TextAreaInput, TextInput, SelectFromArray } from '../../../global/components/forms';

function SentimentQuestionForm({
  cancelLink
  , formTitle
  , formType
  , handleFormChange
  , handleFormSubmit
  , sentimentQuestion
}) {

  // set the button text
  const buttonText = formType === "create" ? "Create Sentiment Question" : "Update Sentiment Question";

  // set the form header
  const header = formTitle ? <div className="formHeader"><h2> {formTitle} </h2><hr/></div> : <div/>;

  return (
    <div className="yt-container">
      <div className="yt-row center-horiz">
        <div className="form-container -slim">
          <form name="sentimentQuestionForm" className="sentiment-question-form" onSubmit={handleFormSubmit}>
            {header}
            { formType == 'create' ? 
              <SelectFromArray
                change={handleFormChange}
                // helpText={"Select type of rating (thumbs, stars,confidence)"}
                items={['thumbs','stars','confidence']}
                label={"Rating Type"}
                name="ratingType"
                required={true}
                value={sentimentQuestion.ratingType}
              />
            : 
              <TextInput
                change={null}
                label="Rating Type"
                maxLength="100"
                name="ratingType"
                // required={true}
                rows="3"
                value={sentimentQuestion.ratingType.charAt(0).toUpperCase() + sentimentQuestion.ratingType.slice(1)}
                disabled={true}
              />
            }
            {/* { sentimentQuestion.ratingType == 'thumbs' ? 
              <div className="yt-row u-pullLeft" style={{backgroundColor: 'gray'}}>
                { Array.from({length: 2}, (_, i) => i + 1).map(option =>
                  <img style={{height: 20, width: 20, color: '#fff', marginRight: 15}} src={'/img/thumbs_up.png'}/>
                )}
              </div>
            : sentimentQuestion.ratingType == 'confidence' ?
              <div className="yt-row u-pullLeft" style={{backgroundColor: 'gray'}}>
                { Array.from({length: 10}, (_, i) => i + 1).map(option =>
                  <div className="confidence-btn center-vert">
                    <p style={{paddingTop: 4}}>{option}</p>
                  </div>
                )}
              </div>
            : sentimentQuestion.ratingType == 'stars' ?
              <div className="yt-row u-pullLeft" style={{backgroundColor: 'gray'}}>
                { Array.from({length: 5}, (_, i) => i + 1).map(option =>
                  <img style={{height: 20, width: 20, color: '#fff', marginRight: 15}} src={'/img/star.png'}/>
                )}
              </div>
            : null
            } */}
            <SelectFromArray
              change={handleFormChange}
              helpText={"Published questions will be shown on sentiment modal"}
              items={['draft','published','archived']}
              label={"Status"}
              name="status"
              required={true}
              value={sentimentQuestion.status}
            />
            <NumberInput
              change={handleFormChange}
              label="Order Weight"
              helpText="1-5 where 1 will be the top question on the modal"
              name="orderWeight"
              step={1}
              // max={6} // should there be a max? 
              min={1}
              value={sentimentQuestion.orderWeight}
            />
            <TextAreaInput
              cols={100}
              change={handleFormChange}
              helpText={<span>{sentimentQuestion.text.length} of 100</span>}
              label="Text"
              maxLength="100"
              name="text"
              required={true}
              placeholder={formType == 'update' ? sentimentQuestion.text : null}
              rows="3"
              value={formType == 'create' ? sentimentQuestion.text : null}
              disabled={formType == 'update'}
            />
            <div className="input-group">
              <div className="yt-row space-between">
                <Link className="yt-btn link" to={cancelLink}>Cancel</Link>
                <button className="yt-btn " type="submit" > {buttonText} </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

SentimentQuestionForm.propTypes = {
  cancelLink: PropTypes.string.isRequired
  , formTitle: PropTypes.string
  , formType: PropTypes.string.isRequired
  , handleFormChange: PropTypes.func.isRequired
  , handleFormSubmit: PropTypes.func.isRequired
  , sentimentQuestion: PropTypes.object.isRequired
}

SentimentQuestionForm.defaultProps = {
  formTitle: ''
}

export default SentimentQuestionForm;



// WEBPACK FOOTER //
// modules/sentimentQuestion/components/SentimentQuestionForm.js.jsx